module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-appbar', {
    staticClass: "syn-appbar",
    attrs: {
      "title": ""
    }
  }, [_c('mu-flat-button', {
    staticClass: "white",
    attrs: {
      "icon": "menu",
      "label": "Menu",
      "color": "white"
    },
    on: {
      "click": function($event) {
        _vm.toggle(true)
      }
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-flat-button', {
    ref: "button",
    attrs: {
      "label": _vm.$auth.user.usr_lastname + ' ' + _vm.$auth.user.usr_firstname,
      "icon": "person"
    },
    on: {
      "click": _vm.toggleUsr
    },
    slot: "right"
  }), _vm._v(" "), _c('mu-popover', {
    attrs: {
      "trigger": _vm.trigger,
      "open": _vm.openUsr
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('mu-menu', [_c('mu-menu-item', {
    attrs: {
      "href": "#/pref",
      "title": "Paramètres",
      "leftIcon": "settings"
    },
    on: {
      "click": function($event) {
        _vm.saveRoute()
      }
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "Se déconnecter",
      "leftIcon": "power_settings_new",
      "leftIconColor": "red"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-drawer', {
    attrs: {
      "open": _vm.open,
      "docked": _vm.docked
    },
    on: {
      "close": function($event) {
        _vm.toggle(true)
      }
    }
  }, [_c('mu-appbar', [_c('img', {
    staticStyle: {
      "height": "44px",
      "vertical-align": "bottom",
      "margin-bottom": "11px"
    },
    attrs: {
      "src": require("../assets/logo_small.svg"),
      "alt": "logo"
    }
  }), _vm._v("\n        Menu\n    ")]), _vm._v(" "), _c('mu-menu', {
    attrs: {
      "autoWidth": false
    },
    on: {
      "itemClick": function($event) {
        _vm.toggle(true)
      }
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "href": "#/dashboard",
      "title": "Tableau de bord",
      "leftIcon": "home"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "href": "#/scan",
      "title": "Scanner",
      "leftIcon": "cast"
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-sub-header', [_vm._v("Administratif")]), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "href": "#/vouch",
      "title": "Récépissés",
      "leftIcon": "receipt"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "href": "#/declaration",
      "title": "Déclaration",
      "leftIcon": "send"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "href": "#/report",
      "title": "Rapports",
      "leftIcon": "show_chart"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "href": "#/map",
      "title": "Carte",
      "leftIcon": "map"
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-sub-header', [_vm._v("Paramétrage")]), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "href": "#/driver",
      "title": "Chauffeurs",
      "leftIcon": "account_circle"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "href": "#/address",
      "title": "Gestion adresse",
      "leftIcon": "add_location"
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), (_vm.user.role == 'admin') ? _c('mu-menu-item', {
    attrs: {
      "href": "#/addressmanage",
      "title": "Traitement adresse",
      "leftIconColor": "#f44336",
      "leftIcon": "build"
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-066d1674"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Headbar.vue
// module id = 414
// module chunks = 1